import { CommonModule } from '@angular/common';
import {
    Component,
    ElementRef,
    OnInit,
    signal,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';
import { InputSelectGeneralComponent } from 'app/components/input-select-general/input-select-general.component';
import { ApplicationService } from 'app/services/application.service';
import { InputGeneralApplicationComponent } from '../input-general-application/input-general-application.component';
import { SelectGeneralApplicationComponent } from '../select-general-application/select-general-application.component';
import { ConfirmInfoComponent } from './confirm-info/confirm-info.component';
import {
    parseJSON,
    isEmpty,
    scrollToFirstInvalidControl,
} from 'app/shared/utils';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { MatDividerModule } from '@angular/material/divider';
import { ApplicationStepperComponent } from 'app/components/application-stepper/application-stepper.component';
import { RevampInputGeneralApplicationComponent } from '../revamp-input-general-application/revamp-input-general-application.component';
import { RevampSelectGeneralApplicationComponent } from '../revamp-select-general-application/revamp-select-general-application.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ToastrService } from 'ngx-toastr';
import { DashboardService } from 'app/modules/dashboard/dashboard.service';

@Component({
    selector: 'business-info',
    templateUrl: './business-info.component.html',
    styleUrls: ['./business-info.component.scss'],
    standalone: true,
    imports: [
        FormsModule,
        CommonModule,
        MatIconModule,
        TranslateModule,
        MatDialogModule,
        ReactiveFormsModule,
        SelectGeneralApplicationComponent,
        InputGeneralApplicationComponent,
        InputSelectGeneralComponent,
        FooterComponent,
        HeaderComponent,
        MatCheckboxModule,
        ConfirmInfoComponent,
        RouterModule,
        MatDividerModule,
        ApplicationStepperComponent,
        RevampInputGeneralApplicationComponent,
        RevampSelectGeneralApplicationComponent,
        MatExpansionModule,
        MatCardModule,
        SlickCarouselModule,
    ],
    styles: [
        `
            :host {
                width: 100%;
            }
        `,
    ],
})
export class BusinessInfoComponent implements OnInit {
    productName: string;
    caseId: any;
    businessInfoForm: FormGroup;
    isRequired: any;
    submitted: boolean = false;
    businessIndustry: string = '';
    numberOfYearsOperation: any;
    profitRecentSelected: any = '';
    howDoYouKnowAboutIMSME: string = '';
    isDraft: any;
    productFlowData;
    toggleDropDown = [false, false, false, false];
    isAuthenticated: boolean = false;
    @ViewChild('formContainer') formContainer!: ElementRef;
    minAnnualSalesTurnover: string;
    businessIndustryOptions = [
        {
            value: '1',
            label: 'COMMON.ELECTRICITY_GAS_WATER',
        },
        {
            value: '2',
            label: 'COMMON.AGRICULTURE_FORESTRY_FISHING',
        },
        {
            value: '3',
            label: 'COMMON.MINING_QUARRYING',
        },
        {
            value: '4',
            label: 'COMMON.MANUFACTURING',
        },
        {
            value: '5',
            label: 'COMMON.TRANSPORT_STORAGE_COMMUNICATION',
        },
        {
            value: '6',
            label: 'COMMON.FINANCING_INSURANCE_REAL_ESTATE_BUSINESS_SERVICE',
        },
        {
            value: '7',
            label: 'COMMON.CONSTRUCTION',
        },
        {
            value: '8',
            label: 'COMMON.WHOLESALE_RETAIL_TRADE_RESTAURANTS_HOTELS',
        },
        {
            value: '9',
            label: 'COMMON.OTHER_SERVICES',
        },
        {
            value: '10',
            label: 'COMMON.TOURISM',
        },
    ];

    numberOfYearsOperationOptions = [
        {
            value: 0.5,
            label: 'LESS_THAN_6_MONTHS',
        },
        {
            value: 0.6,
            label: '6_MONTHS_LESS_THAN_1_YEAR',
        },
        {
            value: 1,
            label: '1_YEAR_TO_LESS_THAN_2_YEARS',
        },
        {
            value: 2,
            label: '2_YEAR_TO_LESS_THAN_3_YEARS',
        },
        {
            value: 3,
            label: '3_YEAR_TO_LESS_THAN_4_YEARS',
        },
        {
            value: 4,
            label: '4_YEAR_AND_ABOVE',
        },
    ];

    listOfProfitableRecent = [];

    howDoYouKnowAboutIMSMEOptions = [
        {
            value: 'Funding Societies',
            label: 'COMMON.FUNDING_SOCIETIES',
        },
        {
            value: 'CGC',
            label: 'COMMON.CGC',
        },
        {
            value: 'Family',
            label: 'COMMON.FAMILY',
        },
        {
            value: 'Others',
            label: 'COMMON.OTHERS',
        },
    ];
    isProfitable: any;
    prodCode: any;
    source: any;
    fromResume: boolean = false;

    caseData: any;
    businessType: any;
    maxAnnualSales = 17;
    maxAnnualSalesError: string;
    isSelectError: string;
    maxPbit = 17;
    maxPbitError: string;
    maxMonthlyInstallment = 15;
    maxComment = 255;
    maxNoOfEmployee = 3;
    maxPaidUpCapital = 15;

    clickedOutside: boolean = false;
    inputError: string;
    noOfEmployeeInputError: string;
    saveDraftMsg;
    closeTostr: string;
    monthlyInstallmentError;
    descriptionError;
    disableSubmitBtn: boolean = false;
    checkMatchingProduct: boolean = false;
    selectedLanguage: any;
    disableSaveDraft = false;
    userData: any = null;
    regBrnNum: any = null;

    value = 35;
    isFocus: boolean = false;
    panelOpenState = signal(true);
    currentSlide: number = 0;
    slideConfig = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
    };

    rightSide = [
        {
            title: 'RIGHT_DIV.TITLE_1',
            subtitle: 'RIGHT_DIV.SUBTITLE_1',
        },
        {
            title: 'RIGHT_DIV.TITLE_2',
            subtitle: 'RIGHT_DIV.SUBTITLE_2',
        },
        {
            title: 'RIGHT_DIV.TITLE_3',
            subtitle: 'RIGHT_DIV.SUBTITLE_3',
        },
    ];

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private applicationService: ApplicationService,
        private _dashService: DashboardService,
        public dialog: MatDialog,
        private translate: TranslateService,
        private toastr: ToastrService,
    ) {
        this.selectedLanguage = localStorage.getItem('language');
        this.isAuthenticated =
            localStorage.getItem('isAuthenticated') == 'true' ? true : false;

        this.productName =
            this.router.getCurrentNavigation().extras.state?.productName;

        this.fromResume =
            this.router.getCurrentNavigation().extras.state?.fromResume;

        this.businessType =
            this.router.getCurrentNavigation().extras.state?.constitutionTypeStdCode;

        this.caseId = this.router.getCurrentNavigation().extras.state?.caseId;
        this.regBrnNum =
            this.router.getCurrentNavigation().extras.state?.regNoo;
        if (!this.caseId) {
            this.caseId =
                this.router.getCurrentNavigation().extras.state?.productFlowData?.caseId;
        }

        // iDA continue flow deep-links with query params on full-page redirect,
        // where Angular navigation state is unavailable.
        const query = new URLSearchParams(window.location.search);
        if (!this.caseId) {
            const qCaseId = query.get('caseId');
            if (qCaseId) {
                this.caseId = qCaseId;
            }
        }
        if (!this.fromResume) {
            const qFromResume = query.get('fromResume');
            this.fromResume = qFromResume === '1' || qFromResume === 'true';
        }

        const qResumeStep = query.get('resumeStep');
        const qProductFlow = query.get('productFlow');
        const qProdCode = query.get('prodCode');
        const qCheckMatching = query.get('checkMatchingProduct');

        this.applicationService.checkCaseIdForRedirection(this.caseId);
        //For check matching products flow
        this.checkMatchingProduct =
            this.router.getCurrentNavigation().extras.state?.checkMatchingProduct;

        if (
            this.checkMatchingProduct === undefined ||
            this.checkMatchingProduct === null
        ) {
            if (qCheckMatching === '1' || qCheckMatching === 'true') {
                this.checkMatchingProduct = true;
            } else if (qCheckMatching === '0' || qCheckMatching === 'false') {
                this.checkMatchingProduct = false;
            } else if (qProductFlow === 'matched') {
                this.checkMatchingProduct = true;
            } else if (qProductFlow === 'select') {
                this.checkMatchingProduct = false;
            }
        }

        this.productFlowData =
            this.router.getCurrentNavigation().extras.state?.productFlowData;

        // Chatbot redirects are full-page navigations, so Angular router state
        // is unavailable. Rebuild the minimal resume context from query params
        // for step 4/5 draft continuation.
        if (
            !this.productFlowData &&
            this.fromResume &&
            (qResumeStep === '4' || qResumeStep === '5')
        ) {
            this.productFlowData = {
                caseId: this.caseId,
                prodCode: qProdCode || '',
                productFlow: qProductFlow === 'matched',
            };
        }

        if (this.fromResume && this.productFlowData) {
            this.disableSaveDraft = true;
        }
    }

    ngOnInit() {
        this.updateTranslation();
        if (this.isAuthenticated == false) {
            this.router.navigate(['/login']);
        }

        this.getCaseDetails(this.caseId).then((data) => {
            if (data.prodSelectionList && data.prodSelectionList.length) {
                if (!this.productName) {
                    this.productName = data.prodSelectionList[0].productName;
                }
                this.prodCode = data.prodSelectionList[0].prodCode;
            }
            this.businessType = data.constitutionTypeStdCode;
            this.source = data.source;

            // Set regBrnNum from case details if not already set (important for resume flow)
            if (!this.regBrnNum && data.companyRegNo) {
                this.regBrnNum = data.companyRegNo;
            } else if (!this.regBrnNum && data.regNo) {
                this.regBrnNum = data.regNo;
            } else if (!this.regBrnNum && data.bizRegNo) {
                this.regBrnNum = data.bizRegNo;
            } else if (!this.regBrnNum && data.registrationNumber) {
                this.regBrnNum = data.registrationNumber;
            }

            this.setFormValues(data);
            if (this.fromResume) {
                this.clearIdaBusinessInfoData();
            } else {
                this.applyIdaBusinessInfoData(data);
            }
            if (this.fromResume && this.productFlowData) {
                this.openEligibilityDialog();
            }
        });

        this.businessInfoForm = this.fb.group({
            businessIndustry: ['', Validators.required],
            yearsOfOperation: ['', Validators.required],
            profitable: [''],
            annualSalesTurnover: [
                '',
                [
                    Validators.required,
                    Validators.maxLength(17),
                    Validators.min(1),
                ],
            ],
            paidUpCapital: [''],
            pbit: ['', [Validators.required, Validators.maxLength(17)]],
            monthlyInstallment: ['', Validators.required],
            noOfEmployee: ['', Validators.required],
            howDoYouKnowAboutUs: ['', Validators.required],
            comment: [''],
            checkbox_1: [false, Validators.requiredTrue],
            checkbox_2: [false, Validators.requiredTrue],
        });
        this.businessInfoForm.get('profitable').disable();

        if (this.businessType == 'SDNBHD') {
            this.businessInfoForm
                .get('paidUpCapital')
                .addValidators([Validators.required]);
            this.businessInfoForm.get('paidUpCapital').updateValueAndValidity();
        } else {
            this.businessInfoForm
                .get('paidUpCapital')
                .removeValidators([Validators.required]);
            this.businessInfoForm.get('paidUpCapital').updateValueAndValidity();
        }
    }

    mapProfitability(profitability: any): any {
        if (profitability == null) {
            this.businessInfoForm.patchValue({
                profitable: 0,
            });
            return 0;
        } else {
            const idx = profitability?.split('');
            return Number(idx[0]);
        }
    }

    convertToNumberFormat(num: string): string {
        return num.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    setFormValues(data: any) {
        this.businessIndustry = data.bizSector;
        this.howDoYouKnowAboutIMSME = data.knowImsmeFrom;
        this.numberOfYearsOperation = data.yearsInOperation;
        if (data.yearsInOperation != null) {
            this.handleNumberOfYearsOperationDetail(
                Number(data.yearsInOperation),
            );
        }

        let profitability;
        if (data.profitability !== '-1') {
            this.onSelectProfitRecent(
                this.mapProfitability(data.profitability),
            );
            profitability = this.businessInfoForm.value.profitable;
        }

        let noOfEmployeeValue;
        if (data.fulltimeEmployee || data.fulltimeEmployee == 0) {
            noOfEmployeeValue = data.fulltimeEmployee;
        } else {
            noOfEmployeeValue = '';
        }

        this.businessInfoForm.patchValue({
            businessIndustry: data.bizSector || '',
            yearsOfOperation: data.yearsInOperation || '',
            profitable: profitability,
            annualSalesTurnover: data.annualSalesTurnover
                ? 'RM' +
                  this.convertToNumberFormat(String(data.annualSalesTurnover))
                : '',
            pbit: data.profitBeforeInterest
                ? 'RM' +
                  this.convertToNumberFormat(String(data.profitBeforeInterest))
                : '',
            monthlyInstallment: data.monthlyInstallment
                ? 'RM' +
                  this.convertToNumberFormat(String(data.monthlyInstallment))
                : '',
            noOfEmployee: noOfEmployeeValue,
            howDoYouKnowAboutUs: data.knowImsmeFrom || '',
            comment: data.comment || '',
            checkbox_1: this.checkCheckboxResponse(data.tncCheckBox) || false,
            checkbox_2:
                this.checkCheckboxResponse(data.noticeCheckBox) || false,
            paidUpCapital: data.paidupCapital
                ? 'RM' + this.convertToNumberFormat(String(data.paidupCapital))
                : '',
        });
    }

    private applyIdaBusinessInfoData(caseData: any): void {
        let raw: string | null = null;
        try {
            raw = localStorage.getItem('ida-business-info-data');
        } catch {
            return;
        }
        if (!raw) {
            return;
        }

        // Clear immediately, so a stale entry from a previous conversation is never reapplied
        try {
            localStorage.removeItem('ida-business-info-data');
            localStorage.removeItem('ida-business-info-data-timestamp');
        } catch {
            /* ignore */
        }

        let ida: Record<string, string>;
        try {
            ida = JSON.parse(raw);
        } catch {
            return;
        }
        if (!ida || typeof ida !== 'object') {
            return;
        }

        const isEmpty = (value: any) =>
            value === undefined || value === null || value === '';

        const merged: any = { ...(caseData || {}) };
        let changed = false;

        // Only fill gaps — never clobber a value the case already carries.
        const fillGap = (apiKey: string, value: any) => {
            if (isEmpty(value) || !isEmpty(merged[apiKey])) {
                return;
            }
            merged[apiKey] = value;
            changed = true;
        };

        fillGap('bizSector', this.normaliseIdaSector(ida.sector));
        fillGap('yearsInOperation', ida.yearsInOperation);
        fillGap('annualSalesTurnover', ida.annualSalesTurnover);
        fillGap('paidupCapital', ida.paidUpCapital);
        fillGap('profitBeforeInterest', ida.profitBeforeInterest);
        fillGap('monthlyInstallment', ida.monthlyInstallment);
        fillGap('fulltimeEmployee', ida.fulltimeEmployee);
        fillGap(
            'knowImsmeFrom',
            this.normaliseIdaKnowImsmeFrom(ida.knowImsmeFrom),
        );
        fillGap('comment', ida.comment);

        // iDA sends the profitability LABEL rather than a code, because the numeric value depends on years in operation.
        if (
            isEmpty(caseData?.profitability) ||
            caseData?.profitability === '-1'
        ) {
            const index = this.mapIdaProfitabilityLabel(ida.profitability);
            if (index !== null) {
                merged.profitability = String(index);
                changed = true;
            }
        }

        if (changed) {
            this.setFormValues(merged);
        }
    }

    private clearIdaBusinessInfoData(): void {
        try {
            localStorage.removeItem('ida-business-info-data');
            localStorage.removeItem('ida-business-info-data-timestamp');
        } catch {
            /* localStorage unavailable */
        }
    }

    /**
     * Normalise the iDA sector code to the format businessIndustryOptions uses.
     */
    private normaliseIdaSector(sector: any): string | null {
        if (sector === undefined || sector === null || sector === '') {
            return null;
        }
        const code = Number(String(sector).trim());
        if (!Number.isInteger(code) || code < 1 || code > 10) {
            return null;
        }
        return String(code);
    }

    /**
     * Normalise "How did you find out about imSME?" to a portal option value.
     */
    private normaliseIdaKnowImsmeFrom(value: any): string | null {
        if (typeof value !== 'string' || !value.trim()) {
            return null;
        }
        const raw = value.trim().toLowerCase();

        // Already canonical (the agent sends codes once redeployed).
        const exact = this.howDoYouKnowAboutIMSMEOptions.find(
            (option) => option.value.toLowerCase() === raw,
        );
        if (exact) {
            return exact.value;
        }

        if (raw.includes('funding societies')) {
            return 'Funding Societies';
        }
        if (raw.includes('cgc')) {
            return 'CGC';
        }
        if (
            raw.includes('family') ||
            raw.includes('friend') ||
            raw.includes('keluarga') ||
            raw.includes('kawan')
        ) {
            return 'Family';
        }
        if (raw.includes('other') || raw.includes('lain')) {
            return 'Others';
        }
        return null;
    }

    /**
     * Map an iDA profitability label to this form's option index.
     * Returns null when the label is missing or unrecognised
     */
    private mapIdaProfitabilityLabel(label: any): number | null {
        if (typeof label !== 'string' || !label.trim()) {
            return null;
        }
        const value = label.toLowerCase();
        if (
            value.includes('non profitable') ||
            value.includes('tidak menguntungkan')
        ) {
            return 0;
        }
        if (value.includes('3')) {
            return 3;
        }
        if (value.includes('2')) {
            return 2;
        }
        if (value.includes('current financial year') || value.includes('1')) {
            return 1;
        }
        return null;
    }

    checkCheckboxResponse(data: any) {
        if (data == null) {
            return false;
        } else {
            return true;
        }
    }

    updateTranslation() {
        this.translate.get('ERROR.IS_REQUIRED').subscribe((data: any) => {
            this.isRequired = data;
        });

        this.translate
            .get('ERROR.NO_OF_EMPLOYEE_ERROR')
            .subscribe((data: any) => {
                this.noOfEmployeeInputError = data;
            });

        this.translate
            .get('ERROR.MONTHLY_INSTALLMENT_ERROR')
            .subscribe((data: any) => {
                this.monthlyInstallmentError = data;
            });

        this.translate.get('ERROR.DESCRIPTION_ERROR').subscribe((data: any) => {
            this.descriptionError = data;
        });

        this.translate
            .get('ERROR.MIN_ANNUAL_SALES_TURNOVER')
            .subscribe((data: any) => {
                this.minAnnualSalesTurnover = data;
            });

        this.translate.get('COMMON.CLOSE').subscribe((data: any) => {
            this.closeTostr = data;
        });

        this.translate
            .get('ERROR.BUSINESS_INFO_SELECT')
            .subscribe((data: any) => {
                this.isSelectError = data;
            });

        this.translate
            .get('ERROR.BUSINESS_INFO_INPUT')
            .subscribe((data: any) => {
                this.inputError = data;
            });

        this.translate
            .get('NEW_APPLICATION.BUSINESS_INFO_SAVE_DRAFT_MSG')
            .subscribe((data: any) => {
                this.saveDraftMsg = data;
            });
    }

    closeAllDropdowns(state: number) {
        for (let i = 0; i < 4; i++) {
            if (i != state) {
                this.toggleDropDown[i] = false;
            } else {
                this.toggleDropDown[i] = true;
            }
        }
        event.stopPropagation();
    }

    closeDropdown() {
        for (let i = 0; i < 4; i++) {
            this.toggleDropDown[i] = false;
        }
    }

    backPage() {
        this.router.navigate(['/corporate'], {
            state: {
                caseId: this.caseId,
                fromResume: true,
                productName: this.productName,
            },
        });
    }

    get f() {
        return this.businessInfoForm.controls;
    }

    countCharacter(str: string, char: string): number {
        const regex = new RegExp(char, 'g');
        const matches = str.match(regex);
        return matches ? matches.length : 0;
    }

    keyPressNumbers(event, isAmount?) {
        const element = event.target as HTMLInputElement;
        const inputValue = element.value;
        let numericValue = '';
        const initialCommas = this.countCharacter(inputValue, ',');
        let selectionStart = element.selectionStart || 0;
        const isBackspace = event.inputType === 'deleteContentBackward'; // Check if the backspace key was pressed

        if (isAmount) {
            const rawValue = inputValue.replace(/[^0-9]/g, '');
            if (rawValue === '') {
                //Amount based inputs
                if (isAmount == 'annualSalesTurnover') {
                    this.businessInfoForm.controls.annualSalesTurnover.patchValue(
                        null,
                    );
                }
                if (isAmount == 'monthlyInstallment') {
                    this.businessInfoForm.controls.monthlyInstallment.patchValue(
                        null,
                    );
                }
                if (isAmount == 'paidUpCapital') {
                    this.businessInfoForm.controls.paidUpCapital.patchValue(
                        null,
                    );
                }
                if (isAmount == 'pbit') {
                    this.businessInfoForm.controls.pbit.patchValue(null);
                }
                return (event.target.value = null);
            }

            numericValue = rawValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            numericValue = `RM${numericValue}`;

            // Adjust cursor position
            const addedCharacters = numericValue.length - inputValue.length;

            if (isBackspace) {
                const prevChar = inputValue[selectionStart - 1];
            } else {
                const prevChar = inputValue[selectionStart - 1];
                if (prevChar === ',' || prevChar === 'R') {
                    selectionStart += addedCharacters - 1;
                } else {
                    selectionStart += addedCharacters;
                }
            }
        } else {
            numericValue = inputValue.replace(/[^0-9]/g, '');
            if (numericValue == '' || inputValue == '') {
                this.businessInfoForm.controls.noOfEmployee.patchValue(null);
            }
        }
        const finalCommas = this.countCharacter(numericValue, ',');
        if (isBackspace && finalCommas < initialCommas) {
            selectionStart -= 1;
        }
        element.value = numericValue;
        const finalCursorPos = Math.min(selectionStart, numericValue.length);
        element.setSelectionRange(finalCursorPos, finalCursorPos);
    }

    pasteNumberOnly(event) {
        let clipboardData = event.clipboardData;
        let pastedData = clipboardData.getData('Text');

        if (isNaN(pastedData)) {
            event.preventDefault();
        } else {
            return;
        }
    }

    getErrors(input: any, inputName?: any, isSelect?: any): Array<any> {
        let errors = [];
        this.updateTranslation();
        if (this.submitted) {
            if (
                input == 'noOfEmployee' &&
                !isSelect &&
                this.f[input].errors?.required
            ) {
                errors.push(this.noOfEmployeeInputError);
            } else if (
                input !== 'noOfEmployee' &&
                !isSelect &&
                this.f[input].errors?.required
            ) {
                errors.push(this.inputError);
            } else if (isSelect && this.f[input].errors?.required) {
                errors.push(this.isSelectError);
            }
            if (input === 'annualSalesTurnover') {
                if (this.f[input].errors?.min) {
                    errors.push(this.minAnnualSalesTurnover);
                }
            }
        }
        return errors;
    }

    handleBusinessIndustryOptions(value: any) {
        this.businessIndustry = value;
        this.businessInfoForm.patchValue({
            businessIndustry: this.businessIndustry,
        });
    }

    handleNumberOfYearsOperationDetail(val: any) {
        this.numberOfYearsOperation = val;
        this.listOfProfitableRecent = [];
        this.profitRecentSelected = '';
        if (this.numberOfYearsOperation <= 0.6) {
            this.listOfProfitableRecent = [];
            this.businessInfoForm.get('profitable').disable();
            this.businessInfoForm.patchValue({
                profitable: null,
            });
            this.profitRecentSelected = null;
        } else if (this.numberOfYearsOperation === 1) {
            this.businessInfoForm.get('profitable').reset();
            this.businessInfoForm.get('profitable').enable();
            this.listOfProfitableRecent = [
                {
                    value: 0,
                    label: 'NON_PROFITABLE',
                },
                {
                    value: 1,
                    label: 'LATEST_1_YEAR',
                },
            ];
        } else if (this.numberOfYearsOperation === 2) {
            this.businessInfoForm.get('profitable').reset();
            this.businessInfoForm.get('profitable').enable();
            this.listOfProfitableRecent = [
                {
                    value: 0,
                    label: 'NON_PROFITABLE',
                },
                {
                    value: 1,
                    label: 'LATEST_1_YEAR',
                },
                {
                    value: 2,
                    label: 'LATEST_2_YEARS',
                },
            ];
        } else if (
            this.numberOfYearsOperation === 3 ||
            this.numberOfYearsOperation === 4
        ) {
            this.businessInfoForm.get('profitable').reset();
            this.businessInfoForm.get('profitable').enable();
            this.listOfProfitableRecent = [
                {
                    value: 0,
                    label: 'NON_PROFITABLE',
                },
                {
                    value: 1,
                    label: 'LATEST_1_YEAR',
                },
                {
                    value: 2,
                    label: 'LATEST_2_YEARS',
                },
                {
                    value: 3,
                    label: 'LATEST_3_YEARS',
                },
            ];
        }

        this.businessInfoForm.patchValue({
            yearsOfOperation: this.numberOfYearsOperation,
        });
    }

    handleHowDoYouKnowABoutIMSMEOptions(val: any) {
        this.howDoYouKnowAboutIMSME = val;
        this.businessInfoForm.patchValue({
            howDoYouKnowAboutUs: val,
        });
    }

    onSelectProfitRecent(element: any) {
        if (this.numberOfYearsOperation <= 0.6) {
            this.profitRecentSelected = null;
            this.businessInfoForm.patchValue({
                profitable: null,
            });
        } else if (this.numberOfYearsOperation > 0.6) {
            if (element == 0) {
                let profitSend = 0;
                this.businessInfoForm.patchValue({
                    profitable: profitSend,
                });
                this.profitRecentSelected = 0;
            } else if (this.numberOfYearsOperation !== 4 && element !== 0) {
                let profitSend =
                    element.toString() +
                    this.numberOfYearsOperation?.toString();
                this.businessInfoForm.patchValue({
                    profitable: profitSend,
                });
                this.profitRecentSelected = element;
            } else if (this.numberOfYearsOperation == 4 && element !== 0) {
                let profitSend = element.toString() + 3;
                this.businessInfoForm.patchValue({
                    profitable: profitSend,
                });
                this.profitRecentSelected = element;
            }
        }
    }

    onSubmit(event, data) {
        this.closeDropdown();

        let annualSalesTurnoverValue;
        if (this.businessInfoForm.value.annualSalesTurnover) {
            this.businessInfoForm.value.annualSalesTurnover =
                this.businessInfoForm.value.annualSalesTurnover
                    .replace('RM', '')
                    .replace(/,/g, '');
            if (isEmpty(this.businessInfoForm.value.annualSalesTurnover)) {
                //If user inputs value and then removes value
                this.businessInfoForm.controls['annualSalesTurnover'].setValue(
                    null,
                );
                annualSalesTurnoverValue = null;
            } else {
                annualSalesTurnoverValue = parseInt(
                    data.annualSalesTurnover
                        .replace(/,/g, '')
                        .replace('RM', ''),
                );
            }
        } else {
            annualSalesTurnoverValue = null;
        }

        let paidupCapitalValue;
        if (this.businessInfoForm.value.paidUpCapital) {
            this.businessInfoForm.value.paidUpCapital =
                this.businessInfoForm.value.paidUpCapital
                    .replace('RM', '')
                    .replace(/,/g, '');
            if (isEmpty(this.businessInfoForm.value.paidUpCapital)) {
                //If user inputs value and then removes value
                this.businessInfoForm.controls['paidUpCapital'].setValue(null);
                paidupCapitalValue = null;
            } else {
                paidupCapitalValue = parseInt(
                    data.paidUpCapital.replace(/,/g, '').replace('RM', ''),
                );
            }
        } else {
            paidupCapitalValue = null;
        }

        let pbitValue;
        if (this.businessInfoForm.value.pbit) {
            this.businessInfoForm.value.pbit = this.businessInfoForm.value.pbit
                .replace('RM', '')
                .replace(/,/g, '');
            if (isEmpty(this.businessInfoForm.value.pbit)) {
                //If user inputs value and then removes value
                this.businessInfoForm.controls['pbit'].setValue(null);
                pbitValue = null;
            } else {
                pbitValue = parseInt(
                    data.pbit.replace(/,/g, '').replace('RM', ''),
                );
            }
        } else {
            pbitValue = null;
        }

        let monthlyInstallmentValue;
        if (this.businessInfoForm.value.monthlyInstallment) {
            this.businessInfoForm.value.monthlyInstallment =
                this.businessInfoForm.value.monthlyInstallment
                    .replace('RM', '')
                    .replace(/,/g, '');
            if (isEmpty(this.businessInfoForm.value.monthlyInstallment)) {
                //If user inputs value and then removes value
                this.businessInfoForm.controls['monthlyInstallment'].setValue(
                    null,
                );
                monthlyInstallmentValue = null;
            } else {
                monthlyInstallmentValue = parseInt(
                    data.monthlyInstallment.replace(/,/g, '').replace('RM', ''),
                );
            }
        } else {
            monthlyInstallmentValue = null;
        }

        let noOfEmployeeValue = parseInt(data.noOfEmployee);

        let objReq = {
            caseId: this.caseId,
            bizSector: data.businessIndustry,
            yearsInOperation: data.yearsOfOperation,
            annualSalesTurnover: annualSalesTurnoverValue,
            paidupCapital: paidupCapitalValue ? paidupCapitalValue : '',
            profitBeforeInterest: pbitValue,
            monthlyInstallment: monthlyInstallmentValue,
            fulltimeEmployee: noOfEmployeeValue,
            knowImsmeFrom: data.howDoYouKnowAboutUs,
            comment: data.comment,
            tncCheckBox: data.checkbox_1,
            noticeCheckBox: data.checkbox_2,
        };

        if (event.submitter.name == 'draft') {
            this.submitted = false;

            if (this.numberOfYearsOperation > 0.6) {
                if (
                    this.profitRecentSelected === null ||
                    this.profitRecentSelected === ''
                ) {
                    objReq['profitability'] = -1;
                } else if (this.profitRecentSelected == 0) {
                    objReq['profitability'] = null;
                } else {
                    objReq['profitability'] = data.profitable;
                }
            } else if (this.numberOfYearsOperation <= 0.6) {
                objReq['profitability'] = null;
            } else if (
                this.profitRecentSelected === null ||
                this.profitRecentSelected === ''
            ) {
                objReq['profitability'] = -1;
            }

            this.isDraft = true;
            objReq['saveDraft'] = this.isDraft;
            this.onSubmitBusinessInfo(objReq);
        }
        if (event.submitter.name == 'next') {
            if (this.businessInfoForm.invalid) {
                scrollToFirstInvalidControl(this.formContainer.nativeElement);
            }
            this.submitted = true;
            if (
                this.numberOfYearsOperation <= 0.6 ||
                this.profitRecentSelected == 0
            ) {
                objReq['profitability'] = null;
            } else {
                objReq['profitability'] = data.profitable;
            }

            this.isDraft = false;
            objReq['saveDraft'] = this.isDraft;

            if (this.numberOfYearsOperation > 0.6) {
                this.businessInfoForm
                    .get('profitable')
                    .setValidators([Validators.required]);
                this.businessInfoForm
                    .get('profitable')
                    .updateValueAndValidity();
            } else {
                this.businessInfoForm.get('profitable').clearValidators();
                this.businessInfoForm
                    .get('profitable')
                    .updateValueAndValidity();
            }

            if (this.businessInfoForm.valid) {
                this.onSubmitBusinessInfo(objReq);
            } else {
                return;
            }
        }
    }

    onSubmitBusinessInfo(objReq) {
        this.updateTranslation();
        if (this.isDraft == false) {
            this.disableSubmitBtn = true;
        } else if (this.isDraft == true) {
            this.disableSubmitBtn = false;
        }
        this.applicationService.businessInfoData(objReq).subscribe({
            next: (res) => {
                if (this.isDraft == false) {
                    this.disableSubmitBtn = false;
                    this.openEligibilityDialog();
                } else {
                    this.disableSubmitBtn = false;
                    this.toastr.success(this.saveDraftMsg);
                }
            },
            error: (err) => {
                this.disableSubmitBtn = false;
                let error = parseJSON(err.error);
                if (error?.data?.comment && error?.data?.comment[0]) {
                    if (localStorage.getItem('language') == 'bm') {
                        this.toastr.error(this.descriptionError);
                    } else {
                        this.toastr.error(error.data.comment[0]);
                    }
                } else if (
                    error?.data?.monthlyInstallment &&
                    error?.data?.monthlyInstallment[0]
                ) {
                    if (localStorage.getItem('language') == 'bm') {
                        this.toastr.error(this.monthlyInstallmentError);
                    } else {
                        this.toastr.error(error?.data?.monthlyInstallment[0]);
                    }
                } else {
                    this.toastr.error(error.message);
                }
            },
        });
    }

    openEligibilityDialog() {
        window.scrollTo({ top: 0 });
        let data;
        if (this.fromResume && this.productFlowData) {
            data = {
                productFlowData: {
                    caseId: this.productFlowData.caseId,
                    prodCode: this.productFlowData.prodCode || this.prodCode,
                    productFlow:
                        typeof this.productFlowData.productFlow === 'boolean'
                            ? this.productFlowData.productFlow
                            : this.checkMatchingProduct,
                    productName: this.productName,
                    fromResume: this.fromResume,
                    source: this.source,
                    type: 'eligibility_check',
                    regNoo: this.regBrnNum,
                },
            };
        } else {
            data = {
                productFlowData: {
                    caseId: this.caseId,
                    prodCode: this.prodCode,
                    productFlow: this.checkMatchingProduct,
                    productName: this.productName,
                    source: this.source,
                    type: 'eligibility_check',
                    regNoo: this.regBrnNum,
                },
            };
        }

        this.dialog.open(ConfirmInfoComponent, {
            backdropClass: 'confirminfo-dialog-background',
            hasBackdrop: true,
            scrollStrategy: new NoopScrollStrategy(),
            panelClass: 'confirminfo-custom-dialog',
            data,
        });
    }

    async getCaseDetails(caseId: string) {
        const value = await this.applicationService
            .getCaseDetails(caseId)
            .toPromise();
        return value[0];
    }

    changeMenuCondition(event: any) {
        this.clickedOutside = false;
    }

    closeMegaMenuCondition() {
        this.clickedOutside = !this.clickedOutside;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (
            changes['close'].currentValue == true ||
            (changes['close'].previousValue == true &&
                changes['close'].currentValue == false)
        ) {
            this.closeDropdown();
        }
    }

    switchLanguageHandler(data: any) {
        this.selectedLanguage = data;
    }

    onFocus() {
        this.isFocus = true;
    }

    onBlur() {
        this.isFocus = false;
    }

    afterChange(e) {
        this.currentSlide = e.currentSlide;
    }

    beforeChange(e) {
        this.currentSlide = e.currentSlide;
    }
}
